import React from "react";
import { P_Props } from "./HtmlEditor.type";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { TCb, UploadedImageModel } from "../../../models";
import { loadCallback } from "../../../utils";
import useNoti from "../../core/useNoti";

export declare module TextEditorModule {
  export interface Props {}
}

const HtmlEditorPresenter: React.FC<P_Props> = (props) => {
  const [pushNoti] = useNoti();
  const [editorHtml, setEditorHtml] = React.useState<string>(props.initValue || "");

  const handleChange = (html: string) => {
    setEditorHtml(html);
  };

  const onImageUploadBefore = (files, info, uploadHandler) => {
    if (files) {
      onUploadAvatar(
        {
          id: undefined,
          file: files[0],
          fileStr: btoa(files[0]),
          alt: "",
        },
        {
          success: (res) => {
            const response = {
              result: [
                {
                  url: props.buildImgSrc(res.data.data),
                  name: res.data.data,
                  size: "",
                },
              ],
            };
            uploadHandler(response);
          },
          error: (err) => {
            uploadHandler();
          },
        }
      );
    } else {
      // do some deleted unneeded images from server
    }
  };

  const onUploadAvatar = (data: UploadedImageModel, cb?: TCb) => {
    const formData = new FormData();
    formData.append("image", data.file);
    props
      .onUploadImg(formData)
      .then((res) => {
        if (res && (res.status === 200 || res.status === 201)) {
          loadCallback(cb?.success, res);
        } else {
          if (res && (res.status === 413))
            pushNoti("error", "File vượt quá dung lượng cho phép");
          else
            pushNoti("error", "Không thể hoàn tất tác vụ");
          
          loadCallback(cb?.error, res);
        }
      })
      .catch((err) => {
        loadCallback(cb?.error, err);
      });
  };

  const options = {
    height: "500px",
    buttonList: [
      ["undo", "redo"],
      ["font", "fontSize", "formatBlock"],
      ["bold", "underline", "italic", "strike", "subscript", "superscript"],
      "/", // Line break
      ["fontColor", "hiliteColor", "textStyle"],
      ["removeFormat"],
      ["outdent", "indent"],
      ["align", "horizontalRule", "list", "lineHeight"],
      ["paragraphStyle", "blockquote"],
      ["table", "link", "image", "video", "audio"],
      // ["table", "link", "image", "video"], // You must add the 'katex' library at options to use the 'math' plugin.
      // ["imageGallery"], // You must add the "imageGalleryUrl".
      // ["fullScreen", "showBlocks", "codeView"],
      ["preview", "print"],
      ["save", "template"], // dont use line break at the end of list
    ],
    resizingBar: false,
    font: ["Arial", "Comic Sans MS", "Courier New", "Impact", "Georgia", "tahoma", "Trebuchet MS", "Verdana", "Be Vietnam"],
  };

  return (
    <div className="html-editor">
      {/* <ReactQuill value={editorHtml} onChange={handleChange} modules={modules} formats={formats} /> */}
      <SunEditor
        defaultValue={editorHtml}
        onChange={handleChange}
        setOptions={options}
        onImageUploadBefore={onImageUploadBefore}
      />
      <div className="html-editor__actions">
        <button
          className="html-editor__actions__cancel"
          onClick={(e) => {
            e.preventDefault();
            props.onCancel();
          }}
        >
          Cancel
        </button>
        <button
          className="html-editor__actions__save"
          onClick={(e) => {
            e.preventDefault();
            props.onSave(editorHtml);
          }}
        >
          Confirm
        </button>
      </div>
    </div>
  );
};

export default HtmlEditorPresenter;
